import { ReactNode } from "react";
import { Box, Skeleton } from "@mui/material";
import { DotLegalHeader, DotLegalPaper } from "@dotlegal/dotlegal-ui-components";
import { RiskExposureCardTone, useRiskExposureCardStyles } from "./RiskExposureCard.styles";
import ArrowDownIcon from "./arrowDown.svg?react";
import ArrowUpIcon from "./arrowUp.svg?react";

interface RiskExposureCardProps {
    isLoading: boolean;
    header: string;
    value: string;
    tone: RiskExposureCardTone;
    icon: ReactNode;
    pillText?: string | null;
    pillArrow?: "up" | "down";
}

function RiskExposureCard({ isLoading, header, value, pillText, tone, icon, pillArrow }: RiskExposureCardProps) {
    const styles = useRiskExposureCardStyles(tone);

    return (
        <DotLegalPaper fullHeight removePadding sx={styles.card}>
            {!isLoading && <Box sx={styles.icon}>{icon}</Box>}
            {isLoading ? (
                <>
                    <Skeleton variant="text" width={160} />
                    <Skeleton variant="rounded" width={140} height={40} sx={{ mt: 2 }} />
                    <Skeleton variant="rounded" width={110} height={24} sx={{ mt: "auto" }} />
                </>
            ) : (
                <>
                    <DotLegalHeader color="primary" headerStyle="medium" marginBottom={0}>
                        {header.toUpperCase()}
                    </DotLegalHeader>
                    <Box sx={styles.value}>{value}</Box>
                    {pillText && (
                        <Box sx={styles.pill}>
                            {pillArrow && (
                                <Box component="span" sx={styles.pillArrow}>
                                    {pillArrow === "up" ? <ArrowUpIcon /> : <ArrowDownIcon />}
                                </Box>
                            )}
                            {pillText}
                        </Box>
                    )}
                </>
            )}
        </DotLegalPaper>
    );
}

export default RiskExposureCard;
